interface QRCodeProps {
  data: string;
  size?: number;
  className?: string;
}

export function QRCode({ data, size = 200, className }: QRCodeProps) {
  return (
    <img 
      src={data} 
      alt="QR Code" 
      width={size} 
      height={size}
      className={className}
    />
  );
}
